import axios from 'axios'
const instance = axios.create({
  baseURL: 'https://e-commerce-1234.herokuapp.com'
})

export default instance
